<template>
  <!-- ************************************************** --
    -- 絞り込みダイアログ
    -- ************************************************** -->
  <!-- 受注チップ -->
  <!-- <modal name="order-filter-dialog" class="modalZIndex" :draggable="true" :resizable="false" width="900" :maxWidth="900" height="275" :maxHeight="275" :reset="true" :clickToClose="false"> -->
  <v-dialog v-model="showDialog" width="900" max-width="90%" style="z-index:500" persistent no-click-animation>
    <v-card>
      <v-toolbar elevation="1" color="#6091d3" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>受注情報絞り込み</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onClickOrderFilterClose" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row no-gutters align-content="center" class="my-1">
            <div class="px-1" style="font-weight:bold;color:navy">入力した内容で絞り込みされます。</div>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-date-box
                    label="運行日"
                    v-model="orderFilterConditions.unkoYmd"
                    />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="客先注文番号あいまい検索"
                    v-model="orderFilterConditions.chumonNo"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                    label="受注営業所コード/名称"
                    v-model="orderFilterConditions.juchuEigyoshoCd"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="営業所マスタ検索"
                    :headerList="mstEigyoshoHeaders"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    :readonly="eigyoshoReadOnly"
                    :itemList="filteredEigyoshoListExcludes99"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="受注営業所あいまい検索"
                    :readonly="eigyoshoReadOnly"
                    v-model="orderFilterConditions.juchuEigyoshoNm"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                    label="作業営業所コード/名称"
                    v-model="orderFilterConditions.sagyoEigyoshoCd"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="営業所マスタ検索"
                    :headerList="mstEigyoshoHeaders"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    :itemList="filteredEigyoshoList"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="作業営業所あいまい検索"
                    v-model="orderFilterConditions.sagyoEigyoshoNm"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                    label="顧客コード/名称"
                    v-model="orderFilterConditions.ninushiCd"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="取引先マスタ検索"
                    :headerList="mstTorihikisakiHeaders"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :itemList="filteredMstTorihikisaki"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="顧客あいまい検索"
                    v-model="orderFilterConditions.ninushiNm"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                      label="積地コード/名称"
                      v-model="orderFilterConditions.hatsuchiCd"
                      :length="100"
                      :required="false"
                      :valueType="Ctrls.InputTypes.Alphanumeric"
                      titleText="発着地検索"
                      :headerList="mstHacchakuchiHeaders"
                      item-value="hacchakuchiCd"
                      item-text="hacchakuchiNm"
                      :itemList="filteredHacchakuchiList"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="積地あいまい検索"
                    v-model="orderFilterConditions.hatsuchiNm"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <div style="width:47%" class="px-1">
                  <dd-time-box
                    label="積時刻"
                    v-model="orderFilterConditions.hatsuchiFromHms"
                  />
                </div>
                <div style="width:6%" class="mt-2 mp-0">～</div>
                <div style="width:47%" class="px-1">
                  <dd-time-box
                    v-model="orderFilterConditions.hatsuchiToHms"
                  />
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                      label="卸地コード/名称"
                      v-model="orderFilterConditions.chakuchiCd"
                      ref="orderFilter.Tsumichi"
                      :length="100"
                      :required="false"
                      :valueType="Ctrls.InputTypes.Alphanumeric"
                      titleText="発着地検索"
                      :headerList="mstHacchakuchiHeaders"
                      item-value="hacchakuchiCd"
                      item-text="hacchakuchiNm"
                      :itemList="filteredHacchakuchiList"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="卸地あいまい検索"
                    v-model="orderFilterConditions.chakuchiNm"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <div style="width:47%" class="px-1">
                  <dd-time-box
                    label="卸時刻"
                    v-model="orderFilterConditions.chakuchiFromHms"
                  />
                </div>
                <div style="width:6%" class="mt-2 mp-0">～</div>
                <div style="width:47%" class="px-1">
                  <dd-time-box
                    v-model="orderFilterConditions.chakuchiToHms"
                  />
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="12" class="px-1">
              <dd-text-box
                label="その他フリー条件"
                v-model="orderFilterConditions.freeWord"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickOrderFilterClose">閉じる</v-btn>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickOrderFilterClear">クリア</v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickOrderFilterExec">OK</v-btn>
      </v-card-actions>
    </v-card>
  <!-- </modal> -->
  </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//
// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'DdHaishaOrderFilterDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    // DdCheckbox,
    DdCodeTextBox,
    // DdDataTable,
    DdDateBox,
    // DdDefaultButton,
    // DdDropDown,
    // DdFooterButton,
    // DdIconButtonWithTooltip,
    // DdNumericBox,
    // DdRadioButton,
    // DdSimpleTable,
    // DdSubHeader,
    // DdSubTitle,
    // DdSwitch,
    // DdTextArea,
    DdTextBox,
    DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: {
      ninushiCd: '',
      ninushiNm: '',
      hatsuchiCd: '',
      hatsuchiNm: '',
      hatsuchiFromHms: '',
      hatsuchiToHms: '',
      chakuchiCd: '',
      chakuchiNm: '',
      chakuchiFromHms: '',
      chakuchiToHms: '',
      freeWord: '',
      juchuEigyoshoCd: '',
      juchuEigyoshoNm: '',
      sagyoEigyoshoCd: '',
      sagyoEigyoshoNm: '',
      unkoYmd: null,
      chumonNo: ''
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,

    // 受注フィルター初期値
    orderFilterConditions: {
      ninushiCd: '',
      ninushiNm: '',
      hatsuchiCd: '',
      hatsuchiNm: '',
      hatsuchiFromHms: '',
      hatsuchiToHms: '',
      chakuchiCd: '',
      chakuchiNm: '',
      chakuchiFromHms: '',
      chakuchiToHms: '',
      freeWord: '',
      juchuEigyoshoCd: '',
      juchuEigyoshoNm: '',
      sagyoEigyoshoCd: '',
      sagyoEigyoshoNm: '',
      unkoYmd: null,
      chumonNo: ''
    },

    // 戻り値用定義
    rec: {
      id: 0
    }
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        this.orderFilterConditions = Object.assign({}, this.param)
        this.initBindVariables()
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredEigyoshoListExcludes99 () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && elem.eigyoshoCd !== '99'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    }
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msthacchakuchi', 'msteigyosho'],
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.orderFilterConditions.juchuEigyoshoCd = !this.eigyoshoLockFlg ? this.userEigyoshoCd : ''
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickOrderFilterClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickOrderFilterExec: function (e) {
      console.log(this.param)
      console.log(this.orderFilterConditions)
      this.$emit('exec', this.orderFilterConditions)
    },
    // --------------------------------------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------------------------------------
    onClickOrderFilterClear: function (e) {
      Object.assign(this.orderFilterConditions, this.$options.data().orderFilterConditions)
      this.$emit('exec', this.orderFilterConditions)
    }
  }
}
</script>
<style></style>
